<template>
  <Modal
    :value="visible"
    @on-cancel="cancelHandler"
    footer-hide
    title="编辑条件"
    width="600"
  >
    <div class="container">
      <Form :model="formData" ref="form" :label-width="100">
        <FormItem label="规则" prop="conditions">
          <div>
            <div style="color: #e91e63">
              规则必须同时满足，该条件才生效
            </div>
            <condition-item
              style="margin-bottom: 10px"
              v-for="(item, index) in formData.conditions"
              :key="index"
              :value="item"
              @input="formData.conditions.splice(index, 1, $event)"
              @delete="formData.conditions.splice(index, 1)"
            />
            <Row>
              <Col span="22" offset="1">
                <Button type="dashed" long @click="addCondition" icon="md-add"
                  >添加规则</Button
                >
              </Col>
            </Row>
          </div>
        </FormItem>
        <div class="flex flex-end">
          <Button style="margin-right: 20px" @click="cancelHandler"
            >取消</Button
          >
          <Button type="primary" @click="submit">确定</Button>
        </div>
      </Form>
    </div>
  </Modal>
</template>
<script>
import { mapState } from "vuex";
import conditionItem from "./ConditionItem.vue";
import cloneDeep from "lodash/cloneDeep";

export default {
  components: { conditionItem },
  model: {
    prop: "visible",
    event: "change",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    curCondition: {
      type: Array,
    },
  },
  data() {
    return {
      formData: {
        conditions: [],
      },
    };
  },
  computed: {
    ...mapState("setting", ["vars"]),
  },
  watch: {
    curCondition(val) {
      if (!val) return;
      this.conditions = cloneDeep(val);
      this.formData = {
        conditions: cloneDeep(val),
      };
    },
  },
  methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const conditions = this.formData.conditions.filter(condition => {
          const { rule, op, value } = condition
          return !!rule && !!op && !!value 
        })
        this.$emit("onSubmit", conditions);
        this.cancelHandler();
      });
    },
    cancelHandler() {
      this.$refs.form.resetFields();
      this.formData = {
        conditions: [],
      };
      this.$emit("onCancel");
    },
    // 添加规则
    addCondition() {
      this.formData.conditions.push({ rule: "", op: "", value: "" });
    },
  },
};
</script>
<style lang="scss" scoped></style>
